/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IBatchUpdateSuggestionsStateMessage {
	ids: string[];
	documentId: string;
	state: string;
}

export default class BatchUpdateSuggestionsStateMessage extends Message {
	public static readonly TYPE: string = '106';

	public static readonly READABLE_TYPE_NAME: string = 'batchUpdateSuggestionsState';

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesBatchUpdateSuggestionsStateMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			ids: {
				type: 'string',
				rule: 'repeated',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			state: {
				type: 'string',
				id: 3
			}
		}
	};

	public constructor(
		public ids: string[],
		public documentId: string,
		public state: string
	) {
		super();
	}

	public toJSON(): IBatchUpdateSuggestionsStateMessage {
		return {
			ids: this.ids,
			documentId: this.documentId,
			state: this.state
		};
	}

	public static fromJSON( object: IBatchUpdateSuggestionsStateMessage ): BatchUpdateSuggestionsStateMessage {
		return new BatchUpdateSuggestionsStateMessage( object.ids, object.documentId, object.state );
	}
}
